import close from '../../../assets/images/close.svg'
import down from '../../../assets/images/down.svg'

const AddCategory = ({
  showAddCategoryPopup,
  popupRef,
  errorMessage,
  formData,
  handleChange,
  setShowAddCategoryPopup,
  handleSubmit,
  handleParentSelect,
  openParent,
  setOpenParent,
  parentDropdownRef,
  bannerList,
  handleBannerSelect,
  bannerDropdownRef,
  setOpenBanner,
  openBanner,
  allCategoryList,
  isSlugChanged,
  setIsSlugChanged,
  setFormData,
  isLoading,
  error
}) => {

  const getCategoryNameById = (id) => {
    const categoryId = typeof id === "object" ? id?.categoryId : id;
    const foundCategory = allCategoryList.find((category) => category.categoryId === categoryId);
    return foundCategory?.name || "Select Parent Category";
  };

  function convertToSlug(str) {
    let slug = str?.toLowerCase();
    slug = slug.trim();
    slug = slug.replace(/[^a-z0-9\s-]/g, '');
    slug = slug.replace(/\s+/g, '-');
    return slug;
  }

  const handleNameChange = (e) => {
    const { value } = e.target;
    handleChange(e);
    if (!isSlugChanged) {
      const slug = convertToSlug(value);
      handleChange({ target: { name: 'slug', value: slug } });
    }
  };

  const handleSlugChange = (e) => {
    handleChange(e);
    setIsSlugChanged(true)
    if (e.target.value === '') {
      setIsSlugChanged(false)
    }
  };

  return (
    <>
      {showAddCategoryPopup && (
        <>
          <div className="popup-overlay"></div>
          <div className="popup-box add-new-user add-category-popup" ref={popupRef}>
            <div className="popupTop popupTopClose closePlan previewClose">
              <img src={close} onClick={() => setShowAddCategoryPopup(false)} alt="Icon" />
            </div>
            <div className='popupModalTitle'>{formData?.categoryId ? 'Edit Category' : 'Add New Category'}</div>
            <div className="popup-form">
              <div className="form-group">
                <label>Name</label>
                <input
                  className='form-input'
                  name='name'
                  value={formData?.name}
                  onChange={handleNameChange}
                  type='text'
                  placeholder="Enter category name"
                />
                {errorMessage?.name && <p className='error-message'>{errorMessage?.name}</p>}
              </div>
              <div className="form-group">
                <label>Slug</label>
                <input
                  className='form-input'
                  name='slug'
                  value={formData?.slug}
                  onChange={handleSlugChange}
                  type='text'
                  placeholder="Enter slug"
                  onBlur={(e) => {
                    let urlValue = convertToSlug(e.target.value);
                    setFormData({ ...formData, slug: urlValue });
                    if (e.target.value === '') {
                      if (!isSlugChanged) {
                        let urlValue = convertToSlug(formData?.name);
                        setFormData({ ...formData, slug: urlValue });
                      }
                    }
                  }}
                />
                {errorMessage?.slug && <p className='error-message'>{errorMessage?.slug}</p>}
              </div>
              <div className="form-group ">
                <label>Parent Category</label>
                <div className="dropdown-wrapper parent-category-list-dropdown" ref={parentDropdownRef}>
                  <div className="dropdown-header " onClick={() => setOpenParent(!openParent)}>
                    <span className="title">
                      {formData?.parent ? getCategoryNameById(formData?.parent) : "Select Parent Category"}
                    </span>
                    <span className={`arrow ${openParent ? "rotate" : ""}`}>
                      <img src={down} alt="down" />
                    </span>
                  </div>
                  {openParent && (
                    <div className="dropdown-list">
                      {allCategoryList?.length > 0 ? (
                        <>
                          {allCategoryList?.map((cat, index) => (
                            <div
                              key={index}
                              className="dropdown-item"
                              onClick={() => handleParentSelect(cat)}
                            >
                              <span>{'—'.repeat(cat?.level)} {cat?.name}</span>
                            </div>
                          ))}
                        </>
                      ) : (
                        <div className="dropdown-item">
                          <span>No data found</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="form-group ">
                <label>Banner</label>
                <div className="dropdown-wrapper parent-category-list-dropdown" ref={bannerDropdownRef}>
                  <div className="dropdown-header " onClick={() => setOpenBanner(!openBanner)}>
                    <span className="title">
                      {Array.isArray(formData?.bannerId) ? (formData?.bannerId.length > 0 ? `${formData?.bannerId.length} selected` : "Select banner") : (formData?.bannerId?.bannerTitle || "Select banner")}
                    </span>
                    <span className={`arrow ${openBanner ? "rotate" : ""}`}>
                      <img src={down} alt="down" />
                    </span>
                  </div>
                  {openBanner && (
                    <div className="dropdown-list">
                      {bannerList?.length > 0 ? (
                        <>
                          {bannerList?.map((banner, index) => (
                            <label
                              key={index}
                              className="dropdown-item"
                            >
                              <input
                                type="checkbox"
                                checked={Array.isArray(formData?.bannerId) ? formData?.bannerId?.some(b => b?.bannerId === banner?.bannerId) : formData?.bannerId?.bannerId === banner?.bannerId}
                                onChange={() => handleBannerSelect(banner)}
                              />
                              <span>{banner?.bannerTitle}</span>
                            </label>
                          ))}
                        </>
                      ) : (
                        <div className="dropdown-item">
                          <span>No data found</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label>SEO content</label>
                <textarea
                  className='form-input description'
                  name='description'
                  value={formData?.description}
                  onChange={handleChange}
                  placeholder="Enter SEO content"
                  rows="5"
                />
                {errorMessage?.description && <p className='error-message'>{errorMessage?.description}</p>}
              </div>
              {error !== "" && error && <p className='error-message'>{error}</p>}
              <div className="popup-actions">
                <button className="cancel-btn" onClick={() => setShowAddCategoryPopup(false)}>Cancel</button>
                <button className="save-btn" onClick={handleSubmit}>
                  {isLoading ?
                    <div className={`ringLoader loaderContinue`}></div>
                    :
                    'Save'
                  }
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default AddCategory
